import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=2067b0dd&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=2067b0dd&prod&lang=less&scoped=true"
import style1 from "./layout.vue?vue&type=style&index=1&id=2067b0dd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2067b0dd",
  null
  
)

export default component.exports